
"use client";

import { GoalsCard } from "@/components/goals-card";
import type { SleepGoal, Child, SleepEvent } from "@/lib/types";

type GoalsTabProps = {
  child: Child;
  goal?: SleepGoal;
  onGoalChange: (newGoal: Omit<SleepGoal, 'id' | 'userId' | 'childId' | 'reminders'>) => void | Promise<void>;
  events: SleepEvent[];
  isSubscribed: boolean;
};

export function GoalsTab({ child, goal, onGoalChange, events, isSubscribed }: GoalsTabProps) {
  return (
    <div className="flex-1 p-4 md:p-6">
      <div className="mx-auto w-full max-w-2xl">
        <GoalsCard child={child} goal={goal} onGoalChange={onGoalChange} events={events} isSubscribed={isSubscribed} />
      </div>
    </div>
  );
}
